import reducer from "./reducers";

import * as customerOperations from "./operations";

export { customerOperations };

export default reducer;